module.exports = __webpack_public_path__ + "media/images/bannerEn-0ae654f426589f319e76b6ddb39f2f79.png";